import type { ReactNode } from 'react';

export const symbol_arrow_top_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M686-575H260v385q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-385q0-24.75 17.63-42.38Q235.25-635 260-635h425L544-776q-9-9-9-21t9.05-21q9.06-9 21.5-9 12.45 0 21.45 9l192 194q5 5 7 10.13 2 5.14 2 11 0 5.87-2 10.87-2 5-7 10L588-391q-9 9-21 8.5t-21.39-9.5q-8.61-9-8.61-21.5t9-21.5l140-140Z"
		/>
	</svg>
);
